const apiUrl = process.env.REACT_APP_API_URL;

export const PostDocument = async (idProjecte: string, nom: string, descripcio: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${idProjecte}/documents`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ nom, descripcio })
        });
        return response;
    } catch (error) {
        console.log('Error:', error);
    }
};
